export default __webpack_public_path__ + "static/media/emoticons.7126849a.png";